import React from "react";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { UpcomingRoyalties } from "@pages/dashboard/UpcomingRoyalties";

const CurrentRoyalties = () => {
  const { participantId } = useTypedParams(ROUTES.Profile.AccountDetails);

  return (
    <div className="pt-5">
      <h4>Future Royalties</h4>
      <UpcomingRoyalties displayBanner={false} payeeId={participantId} />
    </div>
  );
};

export default CurrentRoyalties;
